export const ROUTES = ['cover', 'intro', 'slides', 'summary'];

export const ROUTE_VIEW = {
  cover: 'home',
  intro: 'home',
  slides: 'slides',
  summary: 'summary'
};
